import { useSnapshot } from 'valtio';
import { inboxState } from '../state';

interface UseInboxStateOptions {
  /**
   * If true, the state will be updated immediately when the state changes.
   * If false, the state will be updated after the next render.
   *
   * Useful for driving managed input fields to avoid textbox selection jumping to the end of the text
   * @default false
   */
  sync?: boolean;
}

function useInboxState(options?: UseInboxStateOptions) {
  const { sync = false } = options ?? {};
  return useSnapshot(inboxState, { sync });
}

export default useInboxState;
